const ITEMS = [
  "EXCELLENCE IN DIGITAL ARCHITECTURE",
  "CUSTOM HIGH-PERFORMANCE WEB PLATFORMS",
  "CONVERSION-FOCUSED UI/UX DESIGN",
  "FREDLINE STUDIOS — EST. 2026",
];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display px-8 text-4xl font-extrabold tracking-tight text-outline sm:text-5xl whitespace-nowrap">
            {item}
          </span>
          <span className="h-2.5 w-2.5 rotate-45 bg-cyan-400/70" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#1E2335] py-8 select-none">
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
